import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "dragging-dropping"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.showDrag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true);
}
